import React from "react";
import { ArrowButton } from "../../components/arrow-button";
import { Table } from "antd";

interface MuhammedAliProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}

const names = [
    'Fatıma', 'Meryem', 'Betül', 'Rabia', 'Safiye', 'Hasan', 'Hümeyra', 'Naciye',
    'Emine', 'Abdurrahim', 'Ahmed', 'Ekrem', 'Mahmud', 'Bahri', 'Ali', 'Esma',
    'Mazhar', 'Nuriye', 'Mehmet Ali', 'Lütfullah', 'Ali', 'Yahya', 'Kerim', 'Muhammed',
    'Muhammed Adnan', 'Abdullah', 'Galip', 'Abdullah', 'Cennet', 'Kadriye', 'Kâmile',
    'Mehmet', 'Muzaffer', 'Fatih', 'Cemal', 'Naciye', 'Aliye', 'Bilal', 'Meryem',
    'Hümeyra',
];

const dataSource = names.reduce((acc: any, name, index) => {
    if (index % 2 === 0) {
        acc.push({
            key: Math.ceil(index / 2) + 1,
            person1: `${index + 1}-${name}`,
            person2: names[index + 1] ? `${index + 2}-${names[index + 1]}` : '', // İkinci kişiyi ekle
        });
    }
    return acc;
}, []);


const MuhammedAli = (props: MuhammedAliProps) => {

    const columns = [
        {
            title: null,
            dataIndex: 'person1',
            key: 'person1',
        },
        {
            title: null,
            dataIndex: 'person2',
            key: 'person2',
        },
    ];

    const rowClassName = (record: any, index: any) => {
        return index % 2 === 0 ? 'white-row' : 'gray-row';
    };
    return (
        <div style={{ display: props.isVisible ? "block" : "none" }}>
            <article>
                <ArrowButton onClick={props.comeBackSemaSection} />
                <h4 className="section-title">
                    MUHAMMED ALİ<br />
                    (Arjantinli Yahudî Cemaat Lideri)
                </h4>

                <p className="text-bold">
                    İslam’la müşerref olan Muhammed Ali’nin
                    hidayet öyküsünü kendi ağzından dinleyelim:
                </p>

                <p>
                    Arjantinli dindar Yahudî bir anne ve babadan dünyaya geldim. İlk dini eğitimimi evimizin yakınında bulunan bir Sinagog’da aldım. Zamanımın çoğunu oradaki Hahamlardan ders almakla geçiriyordum. Yahudîliği iyice anlayabilmem için bana İbranîce öğrettiler. Küçüklüğümden beri <span className="text-bold">‘Allah’ın dini</span>’nin ayrım yapmaksızın herkesi kuşatan bir din olarak hayal eder ve düşünürdüm. Ama araştırmalarım derinleştikçe Yehova Şahitleri’nin “Allah yalnız bizim, O yalnız bizimle konuşur.” türden sadece Yahudileri üstün tutan bu inancı bana saçma geliyordu. Bu yüzden dine olan saygı ve sevgimi yitirmiştim. Sinagog ve Havra’dan soğuyup iyice uzaklaştım. İçimde artık din sevgisi kalmamıştı.
                </p>

                <p>
                    O sıralarda 18 arkadaşımla birlikte bir İstanbul seyahati gerçekleştirdim. Bir arkadaşımızın vesilesi ile İstanbul’un Fatih Semti’nde bulunan Zaviyede Ali Yakub Baba ile tanıştık ve oradaki sufî cemaatle buluştuk.
                </p>

                <p>
                    <span className="text-bold">Hz. Mevlana’nın: “Gel, gel… Ne olursan ol yine gel. Yüz bin defa tövbeni bozmuş olsan da yine gel… Bizim dergâhımız ümitsizlik dergâhı değildir.”</span> çağrısını işittik. Sufilerin namaz, zikir, sema ve sohbetlerinden çok etkilendik. Aklımızdaki tüm sorulara cevap bulduk. Şeref-i İslam’la müşerref olduk.
                </p>
                <p>
                    <span className="text-bold">“Amentü billahi ve melâiketihi,ve kütübihî ve rusülihî ve’l yevmi’lâhıri ve bi’l-kaderi, hayrihî ve şerrihi mina’llâhi teâlâ ve’l-ba’sü ba’de’l mevt. Hakkun, Eşhedü en lâ ilâhe illallâh ve eşhedü enne Muhammeden abdühû ve rasûlühü.”</span> deyip kelime-i şehadet getirerek İslam’la müşerref olduk.
                </p>

                <p className="text-bold">
                    İslam’ın esasları olan Kelime-i Şahadet, Namaz, Oruç, Zekât ve Hac bana talim buyruldu.
                </p>

                <p>
                    Bana İslamî bir isim seçebileceğim söylendi. Ben de İbranice ismimin anlamının ‘Aslan’ olmasından dolayı “Allah’ın aslanı olan Ali ismini bana verirseniz Müslüman olurum” dedim. Ve böylece <span className="text-bold">Muhammed Ali</span> ismini aldım.
                </p>
                <p>
                    Benimle birlikte 18 arkadaşım da İslam’la müşerref olma zevkine eriştiler. Hidayet güneşinin nurunun eski dindaşlarıma da doğmasını Cenab-ı Allah’tan niyaz ediyorum.
                </p>

                <p>
                    Ali Yakub Baba bundan iki sene sonra Şebi Arus Programı için Galata Mevlevihanesi’ne ziyarete gitmişti. Orada meşhur Ankaravi Hazretleri ve diğer Mevlevi büyüklerin türbelerini ziyaret ettikten sonra Muhammed Ali ile karşılaştı. Hemen selamlaşıp kucaklaştılar. Yakub Baba’nın yanında bulunanlar bu duruma şaşırdılar. Bunun üzerine Muhammed Ali “Arjantin ve Brezilya’dan olmak üzere toplam 40 kişi olarak buraya geldik.” dedi. Gelen misafirler Ali Yakub Baba ile tanıştılar. Misafirler daha önce Konya’daki Şebi Arus programını izlemişlerdi. Şimdi de buradaki Şebi Arus programı için Galata Mevlevihanesi’ne gelmişlerdi.
                </p>

                <p>
                    Orada bulunan acenta müdürü misafirler için Çırağan Palace otelinde yemek hazırlattıklarını söyledi. Bunun üzerine Ali Yakub Baba: “Misafirlere ne arzu ettiklerini sorun” dedi. Misafirler de “Ali Yakub Baba’yı ziyaret etmek için buraya geldik.” dediler ve otele gitmek istemediklerini söylediler. Daha sonra Ali Yakub Baba ile Fatih’te bulunan Zaviyeye gittiler. Zaviyede yemek yedikten sonra sohbet etmeye başladılar. Akşam 6’ dan gece 1’e kadar uzun bir sohbette bulundular. O gece 40 kişi İslam ile müşerref oldu. Daha sonra misafirler otellerine geri döndüler. Ertesi gün Ali Yakub Baba Beyazıt’ta bulunan Sahaflar Çarşısı’na gitti. Yeni Müslüman olmuş misafirlere hediye etmek üzere birer tane Portekizce Kur’an-ı Kerim aldı. Misafirler, birkaç gün sonra Ali Yakub Baba’yı otelde kahvaltıya davet ettiler. Orada kahvaltı edip sohbet ettikten sonra Ali Yakub Baba Kuran’ı Kerimleri hediye etti. Misafirler 5 gün daha İstanbul’da kaldıktan sonra ülkelerine döndüler.
                </p>

                <p>
                    Müslüman olan 40 kişinin İslamî isimleri şöyleydi:
                </p>

                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey="key"
                    bordered
                    title={() => null}
                    className="no-header-table"
                    rowClassName={rowClassName}
                />
            </article>
        </div>
    );
}

export default MuhammedAli;